import { render, staticRenderFns } from "./BookSummarySkelton.vue?vue&type=template&id=61893379&scoped=true&"
var script = {}
import style0 from "./BookSummarySkelton.vue?vue&type=style&index=0&id=61893379&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61893379",
  null
  
)

export default component.exports